export default "https://cdn-static.gokick.com/assets/10f8238ac2c3e70096f19214fcd9b55856558067/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";